import { Dispatch, SetStateAction } from 'react'

import { BILLING_SEARCH_CONDITION_CLEAR, BillingSearchCondition } from '@/common/api/modules/billing'
import { isSameSearchCondition } from '@/common/api/search'

import Button from '@/components/view/atoms/button/Button'
import Selector from '@/components/view/atoms/selector/Selector'
import SearchConditionAreaContent from '@/components/view/layouts/area/SearchConditionAreaContent'
import SortButtonList from '@/components/view/layouts/button/SortButtonList'

const STATUS_CHOICES = [
  { value: '', name: '全ステータス' },
  { value: 'draft', name: '下書き' },
  { value: 'confirmed', name: '確定' },
  { value: 'invoiced', name: '請求済' },
  { value: 'paid', name: '入金済' }
]

interface Props {
  condition: BillingSearchCondition
  setCondition: Dispatch<SetStateAction<BillingSearchCondition>>
}

const BillingSearchConditionField = ({ condition, setCondition }: Props) => {
  const isDefault = isSameSearchCondition(condition, BILLING_SEARCH_CONDITION_CLEAR)

  return (
    <SearchConditionAreaContent>
      <SortButtonList>
        <Selector
          name='status'
          choices={STATUS_CHOICES}
          value={condition.status ?? ''}
          onChange={(e) =>
            setCondition((prev) => ({
              ...prev,
              page: 1,
              status: e.target.value || null
            }))
          }
        />
        <Button
          color='secondary'
          disabled={isDefault}
          onClick={() => setCondition(BILLING_SEARCH_CONDITION_CLEAR)}
        >
          条件をリセット
        </Button>
      </SortButtonList>
    </SearchConditionAreaContent>
  )
}

export default BillingSearchConditionField
